<template>
  <div v-if="!isConnectionProcessed" class="text-center p-5 " style="width: 100%; position: absolute;">
    <img src="../../../assets/images/turnitin-logo.png" width="200"/>
    <h2 class="mb-3 mt-3">Connect Turnitin</h2>

    <center>
      <h6 style="text-align: left; max-width: 500px;" class="mb-3">
        To connect Turnitin account, log into your Turnitin Core API account and create a new
        integration. Once created, locate the "API URL", "API Key" and "Integration Name" within
        the integration settings. Alerts about this connection will be sent to the email address
        you enter.
      </h6>
      <div style="max-width: 350px;">
        <input
            v-model="turnitinServiceObj.apiUrl"
            autocomplete="off"
            type="text"
            placeholder="Enter Turnitin API URL"
            class="search-input mt-3"
        />
        <input
            v-model="turnitinServiceObj.apiKey"
            autocomplete="off"
            type="search"
            placeholder="Enter Turnitin API Key"
            class="search-input mt-3"
        />
        <input
            v-model="turnitinServiceObj.integrationName"
            autocomplete="off"
            type="text"
            placeholder="Enter Integration Name"
            class="search-input mt-3"
        />
        <b-form-tags class="form-input mt-3 webhook-alert-emails-input" input-id="turnitinServiceEmails" v-model="turnitinServiceObj.email"
          separator="," :placeholder="!turnitinServiceObj.email || turnitinServiceObj.email.length === 0
            ? 'Enter failure alert email addresses'
            : ''" size="sm" tag-pills></b-form-tags>
        
      <div class="p-1 alert-info webhook-email-instructions-div font-weight-bold" role="alert"
          v-if="turnitinServiceObj.email && turnitinServiceObj.email.length > 0">
          <p class="font-weight-bold">In case of frequent failures, a notification will be sent to these email addresses.</p>
        </div>

        <p v-if="error" class="text-danger mt-3 mb-2">{{ error }}</p>
        <button @click="connectTurnitin" class="connect-btn step-btn mt-3 mb-3">Connect</button>
      </div>
    </center>
  </div>
  <div v-else class="ms-5 pt-5">
    <h2 class="pb-5 mt-1">Connecting Turnitin<br/><small>Testing connection...</small></h2>
    <h5 v-if="message">{{ message }}</h5>
    <h5 v-if="error" class="text-danger">{{ error }}</h5>
  </div>

</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "TurnitinServiceApp",
  data() {
    return {
      message: undefined,
      error: undefined,
      isConnectionProcessed: false,
      turnitinServiceObj: {
        apiUrl: "",
        apiKey: "",
        integrationName: "",
        email: [],
        webhookSigningSecret: ""
      }
    };
  },
  methods: {
    ...mapActions("appState", ["createExternalServices"]),

    generateSigningSecret() {
      // webhook signature validation Base64-decodes this value, so it must be valid Base64
      const array = new Uint8Array(24);
      window.crypto.getRandomValues(array);
      return btoa(String.fromCharCode(...array));
    },


    connectTurnitin() {
      this.error = null;
      if (this.turnitinServiceObj &&
          this.turnitinServiceObj.apiUrl &&
          this.turnitinServiceObj.apiKey &&
          this.turnitinServiceObj.integrationName &&
          this.turnitinServiceObj.email.length > 0 &&
          this.turnitinServiceObj.webhookSigningSecret) {

        this.isConnectionProcessed = true;
        this.createExternalServices({
          type: "TurnitinSimilarityCheck",
          provider: "turnitin",
          data: { ...this.turnitinServiceObj, email: this.turnitinServiceObj.email.join(";") }
        }).then((response) => {
          if (response && response.error && response.error.message) {
            this.isConnectionProcessed = false;
            this.error = response.error.message;
            return;
          }

          if (response && response.message) {
            this.isConnectionProcessed = false;
            this.error = response.message;
            return;
          }

          if (response) {
            if (window.opener.beforeCloseCallback) {
              window.opener.beforeCloseCallback();
            }
            window.close();
          } else {
            this.isConnectionProcessed = false;
            this.error = "Some error occured. ERR_CODE: 002";
          }

        }).catch((err) => {
          this.isConnectionProcessed = false;
          this.error = "Some error occured. ERR_CODE: 003";
        });

      } else {
        this.error = "Please fill all the fields";
      }
    }
  },
  created() {
    this.turnitinServiceObj.webhookSigningSecret = this.generateSigningSecret();
  }
}
</script>

<style scoped>
.search-input {
  background: #ffffff;
  border: 1px solid #dcdcdc;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 0.5rem 0.75rem;
  width: 100%;
  text-align: left;
  color: #000000;
  font-size: 1.5rem;
  column-gap: 0.75rem;
  position: relative;
  outline: none;
}


.connect-btn {
  background-color: #2D8CFF;
  border: #2D8CFF;
  color: #ffffff;
  font-size: small;
}
.step-btn {
  width: 100%;
}
.webhook-alert-emails-input{
  box-shadow: none;
  padding: 0.5rem 0.75rem;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
}
.webhook-email-instructions-div{
  text-align: left;
  border-radius: 5px;
}

</style>
